import types, { AdCampaignProductState } from './types';
import actionCreators from './actions';
import { ValueOf } from 'sl-api-connector';
import { AD_STATUS_DERIVED, AD_CAMPAIGN_STATUS } from 'sl-ad-campaign-manager-data-model';

// ------------------------------------
// Reducer
// ------------------------------------

const adTargetStatesAvailable: AdCampaignProductState[] = [
  {
    id: AD_CAMPAIGN_STATUS.ENABLED,
    campaignProductState: AD_CAMPAIGN_STATUS.ENABLED,
    name: 'Enabled',
    displayName: 'Enabled',
    type: 'adCampaignProductState'
  },
  {
    id: AD_STATUS_DERIVED.PAUSED,
    campaignProductState: AD_STATUS_DERIVED.PAUSED,
    name: 'Paused',
    displayName: 'Paused',
    type: 'adCampaignProductState'
  }
];
type Action = ValueOf<{ [K in keyof typeof actionCreators]: ReturnType<(typeof actionCreators)[K]> }>;

export function adCampaignProductStates(state = adTargetStatesAvailable, action: Action) {
  switch (action.type) {
    case types.RECEIVE_AD_CAMPAIGN_PRODUCT_STATES:
      return action.adCampaignProductStates;
    case types.CLEAR_AD_CAMPAIGN_PRODUCT_STATES:
      return [];
    default:
      return state;
  }
}
